// Vendor
import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class AnchorLink extends Component {
  static propTypes = {
    href: PropTypes.string.isRequired,
    offset: PropTypes.number,
  };

  static defaultProps = {
    offset: 0,
  };

  componentDidMount() {
    require('smoothscroll-polyfill').polyfill();
    this.documentOffset = require('document-offset');
  }

  smoothScroll = e => {
    e.preventDefault();
    const id = this.props.href.slice(1);
    const targetElement = document.getElementById(id);

    if (targetElement) {
      const scrollTopOffset = this.documentOffset(targetElement).top - this.props.offset;

      window.scroll({
        top: scrollTopOffset,
        behavior: 'smooth',
      });
    }

    if (this.props.onClick) {
      this.props.onClick(e);
    }
  };

  render() {
    return <a {...this.props} onClick={this.smoothScroll} />;
  }
}



// WEBPACK FOOTER //
// components/AnchorLink/index.js